import pullAllRight from './pullAllRight'
export default function pullRight(data, ...values) {
  return pullAllRight(data, values)
}
